export const allowablePrefix = (
  homeActive: boolean,
  landlordActive: boolean
): string[] => {
  const prefix = ['COMO'];
  if (homeActive) {
    prefix.push('COHO');
  }
  if (landlordActive) {
    prefix.push('COLA');
  }
  return prefix;
};

export const setQuoteIdPattern = (
  homeActive: boolean,
  landlordActive: boolean
) => {
  let prefixPattern = /^COMO\d{8}$/;
  if (homeActive && landlordActive) {
    prefixPattern = /^CO(HO|LA|MO)\d{8}$/;
  } else if (!landlordActive && homeActive) {
    prefixPattern = /^CO(HO|MO)\d{8}$/;
  } else if (!homeActive && landlordActive) {
    prefixPattern = /^CO(LA|MO)\d{8}$/;
  }
  return prefixPattern;
};

export const regexPrefixMatch = (
  prefixes: string[],
  value: string
): boolean => {
  const regexPattern = new RegExp(`^${value}`);
  for (let i = 0; i < prefixes.length; i += 1) {
    const prefix = prefixes[i];
    const prefixMatch = prefix.match(regexPattern);
    if (prefixMatch !== undefined && prefixMatch !== null) {
      return true;
    }
  }
  return false;
};
